/**
 * Import des styles et des modules
 * ****************************************
 */
import "../sass/style.scss";
import Datalayers from "./modules/Datalayers";
import Utm from "./modules/Utm";

function doOnDocumentLoaded() {
    loaderInit();
}

// Avoid Transition on page load
window.addEventListener("load", () => {
    document.body.classList.remove("preload");
});

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", doOnDocumentLoaded);
} else {
    doOnDocumentLoaded();
}

/**
 * Initialisation des modules
 * ******************************
 */
function loaderInit() {
    Utm();
    Datalayers();
}
